import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { CardS } from '../../GlobalStyles';
import { AppStore } from '../../store/applicationState';
import { GROUP_SEMINAR, TYPE_ID } from '../../utils/consts';
import { EIcons } from '../../utils/globatTypes';
import writtenTimeFormat from '../../utils/writtenTimeFormat';
import { TitleBlock } from '../TitleBlock';
import { Test } from './components/Test';

interface InteractiveProps {}

export const FinalTest: React.FC<InteractiveProps> = () => {
  const { Sockets, FinalTest, Certeficate } = useSelector((store: AppStore) => store);
  const [time, setTime] = React.useState(0);

  const { loading, data, error } = FinalTest;
  const { room } = Sockets;

  React.useEffect(() => {
    if (data?.endDate) {
      // const dif =  - new Date().getTime();
      setTime(new Date(data.endDate).getTime());
    }
  }, [data]);

  React.useEffect(() => {
    let timer: NodeJS.Timeout;
    if (time > 0) {
      timer = setInterval(() => setTime(time - 1000 * 60), 1000 * 60);
    }
    return () => clearInterval(timer);
  }, [time]);

  const renderBody = () => {
    if (!room)
      return (
        <BodyS>
          <div> Нема кiмнати </div>
        </BodyS>
      );
    if (loading)
      return (
        <BodyS>
          <div> Загрузка ... </div>
        </BodyS>
      );
    if (error)
      return (
        <BodyS>
          <div style={{ color: 'red', marginTop: '20px', textAlign: 'center' }}>
            <span>{error}</span>
          </div>
        </BodyS>
      );
    if (!data) return <div> Загрузка ... </div>;
    if (Sockets.event?.group_id === GROUP_SEMINAR.MED && Sockets.event?.type_id !== TYPE_ID.WEBINAR) {
      if (data?.endDate && new Date(data?.endDate) < new Date() && !data.isDone)
        return (
          <WrapperTimerS>
            Термін на проходження фінального тесту вичерпаний. Пройти тест можливо було до {moment(data.endDate).format('DD.MM.YYYY')}
          </WrapperTimerS>
        );
      return (
        <BodyS>
          {data.endDate && new Date(data.endDate) > new Date() && !Certeficate.data?.certeficate?.is_done ? (
            <WrapperTimerS>
              Через {writtenTimeFormat(time)} доступ до фінального тесту закриється. Встигніть пройти тестування, щоб отримати сертифікат!
            </WrapperTimerS>
          ) : null}
          <TestWrapperS>
            <Test />
          </TestWrapperS>
        </BodyS>
      );
    }
    return (
      <BodyS>
        <TestWrapperS>
          <Test />
        </TestWrapperS>
      </BodyS>
    );
  };

  return (
    <WrapperS>
      <div>
        <TitleBlock title="Фiнальний тест" icon={EIcons.final} />
      </div>
      {renderBody()}
    </WrapperS>
  );
};

const WrapperS = styled(CardS)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const WrapperTimerS = styled.h4`
  padding: 20px 50px;
  margin: 0;
`;

const BodyS = styled.div`
  flex: 1;
  overflow: auto;
`;

const TestWrapperS = styled.div`
  padding: 20px 0;
`;
